<template>
  <FreeBottomSheet :name="PROFILE_LINKS_BOTTOM_SHEET_NAME">
    <template #header="{ hide }">
      <FreeHeader class="text-text-neutral-primary p-4">
        <template #default>
          <h3 class="text-lg font-semibold">
            {{ t('mainPageHeader.profile') }}
          </h3>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div
        class="bg-background-neutral-secondary text-text-neutral-primary mx-4 mt-2 mb-5 rounded-2xl"
      >
        <TabBarButton
          class="w-full"
          data-qa-id="tabbar.cabinet"
          @onClick="handleTabBarItemClick(App.CABINET)"
        >
          <template #icon>
            <img
              src="./assets/tickets.svg"
              width="40"
              height="40"
              alt=""
              role="presentation"
            />
          </template>
          <template #label>
            {{
              searchAppType === FlowType.TOURS
                ? t('mainPageHeader.myTours')
                : t('mainPageHeader.myTickets')
            }}
          </template>
        </TabBarButton>
        <TabBarButton
          class="w-full"
          data-qa-id="tabbar.passengers"
          @onClick="handleTabBarItemClick(App.PASSENGERS)"
        >
          <template #icon>
            <img
              src="./assets/passengers.svg"
              width="40"
              height="40"
              alt=""
              role="presentation"
            />
          </template>
          <template #label>
            {{ t('mainPageHeader.passengers') }}
          </template>
        </TabBarButton>
        <TabBarButton
          v-if="[FlowType.AVIA, FlowType.RAILWAYS].includes(searchAppType)"
          class="w-full"
          data-qa-id="tabbar.customer-support"
          @onClick="handleTabBarItemClick(App.CUSTOMER_SUPPORT)"
        >
          <template #icon>
            <img
              src="./assets/phone.svg"
              width="40"
              height="40"
              alt=""
              role="presentation"
            />
          </template>
          <template #label>
            {{ t('mainPageHeader.customerSupport') }}
          </template>
        </TabBarButton>

        <slot :name="FlowType.TOURS" />
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { controllerModel } from 'shared';

  import messages from '../config/locales.json';
  import {
    FreeBottomSheet,
    FreeCloseButton,
    FreeHeader,
  } from '../../../shared/ui';
  import { appNavLinks } from '../../../shared/lib';
  import { FlowType, App } from '../../../shared/config';
  import { PROFILE_LINKS_BOTTOM_SHEET_NAME } from '../config';
  import TabBarButton from './TabBarButton.vue';

  const props = withDefaults(
    defineProps<{
      searchAppType?: FlowType;
    }>(),
    {
      searchAppType: FlowType.AVIA,
    },
  );
  const emit = defineEmits<{
    onStartLoading: [];
    onMyTicketsClick: [];
  }>();

  const { t } = useI18n({ messages });
  const bottomSheet = controllerModel.useBottomSheet();

  const handleTabBarItemClick = (miniAppName: App) => {
    emit('onStartLoading');
    bottomSheet.hide(PROFILE_LINKS_BOTTOM_SHEET_NAME);

    switch (miniAppName) {
      case App.CABINET:
        emit('onMyTicketsClick');
        appNavLinks.openCabinet(
          props.searchAppType,
          `?source=${props.searchAppType}_menu_sidebar`,
        );
        break;
      case App.PASSENGERS:
        appNavLinks.openPassengers(props.searchAppType);
        break;
      case App.CUSTOMER_SUPPORT:
        appNavLinks.openCabinet(
          'customer-support',
          `?source=${props.searchAppType}_menu_sidebar`,
        );
        break;
    }
  };
</script>
